export default "__VITE_ASSET__BepzxFzY__"